import api from "../../services";

export const updateBook = async (data, id) => {
    try {
        if (!data || !id) {
            throw new Error("Missing data or book id");
        }

        const formData = new FormData();

        Object.entries(data).forEach(([key, value]) => {
            if (value !== null && value !== undefined) {
                formData.append(key, value);
            }
        });

        // Debug FormData properly
        for (let pair of formData.entries()) {
            console.log("here", pair[0], pair[1]);
        }
        console.log("formData", formData)
        const response = await api(
            "POST",
            `update-book/${id}`,
            formData,
            true
        );

        return response;

    } catch (error) {
        console.error("Update Book Error:", error);
        throw error;
    }
};


export const moveBook = (id, fromSetter, toSetter, row, newStatus) => {
    fromSetter(prev => (prev || []).filter(book => book.book_id != id));

    toSetter(prev => {
        const currentList = prev || [];

        if (currentList.some(book => book.book_id == id)) return currentList;

        return [{ ...row, status: newStatus }, ...currentList];
    });
};